import React from 'react';
import PropTypes from 'prop-types';

const DisplayErrorMessages = ({ entryErrors }) => {
  const errorMessage = (attribute, message) => {
    if (attribute === 'completed' || message.includes('It looks like this site already exists')) {
      return message;
    }
    return `'${attribute}' ${message}`;
  };
  return (
    (
      <ul className="space-y-0.5 pr-3" data-testid="import-errors">
        {entryErrors.map((error) => (
          error.messages.map((message) => (
            <li key={message} className="text-vamos-red text-sm font-bold list-disc text-left" data-testid="import-single-error">
              <span>{errorMessage(error.attribute, message)}</span>
            </li>
          ))
        ))}
      </ul>
    )
  );
};

DisplayErrorMessages.propTypes = {
  entryErrors: PropTypes.arrayOf(
    PropTypes.shape({
      attribute: PropTypes.string.isRequired,
      messages: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default DisplayErrorMessages;
